

export const chainListApi = 'chain';
export const chainAsset = 'chain-asset';
export const baseURL = 'https://content.subwallet.app/api/list/'